'use strict';

export default class OPLRequestTitle {
    constructor() {
        this.requestTitleWrapper = null;
        this.form = null;
        this.sharepointTableInput = null;
        this.isbnWrapper = null;
        this.isbnInput = null;
        this.formatDropdown = null;
    }

    init() {
        this.requestTitleWrapper = document.querySelector('#request-title-wrap');
        this.form = document.querySelector('#request-title-form');
        this.sharepointTableInput = document.querySelector('#FormModel_SharepointTable');
        this.isbnWrapper = document.querySelector('#request-title-form-isbn-wrapper');
        this.isbnInput = document.querySelector('#FormModel_Isbn');
        this.formatDropdown = document.querySelector('#FormModel_Format');

        if (this.form) {
            this.handleFormatDropdownChange(); // in case the form is reloaded.
            this.formatDropdown.addEventListener('change', () => {
                this.handleFormatDropdownChange();
            });
            this.form.addEventListener('submit', (e) => {
                this.handleFormSubmit(e);
            });
        }
    }

    handleFormatDropdownChange() {
        if (this.formatDropdown.value !== '') {
            const selectedOption = this.formatDropdown.options[this.formatDropdown.selectedIndex];
            this.sharepointTableInput.value = selectedOption.dataset.sptable;

            if (selectedOption.dataset.isbn === 'True') {
                this.isbnWrapper.style.display = 'block';
                this.isbnInput.required = true;
            } else {
                this.isbnWrapper.style.display = 'none';
                this.isbnInput.required = false;
                this.isbnInput.value = '';
            }
        }
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);

        fetch("/api/request-title/form", {
            method: "POST",
            body: formData,
        })
            .then(response => {
                if (!response.ok) throw new Error("Form submission failed");
                return response.text();
            })
            .then(html => {
                this.requestTitleWrapper.innerHTML = html;
                this.init();
            })
            .catch(error => {
                console.error("Error submitting form:", error);
            });
    }
}
